module.exports = __webpack_public_path__ + "static/media/mobile-holes.svg";